export function LogoGrayLarge({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width='120'
      height='100'
      viewBox='0 0 120 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g opacity='0.25'>
        <path
          d='M17.4038 0C26.5438 0 33.9594 7.52076 33.9594 16.7905V59.9912C33.9594 69.261 26.5438 76.7817 17.4038 76.7817C8.26368 76.7817 0.848145 69.261 0.848145 59.9912V16.7905C0.848145 7.52076 8.26368 0 17.4038 0Z'
          fill='url(#paint0_linear_2080_38681)'
        />
        <path
          d='M60.0001 23.2182C69.1402 23.2182 76.5557 30.739 76.5557 40.0088V83.2095C76.5557 92.4792 69.1402 100 60.0001 100C50.86 100 43.4444 92.4792 43.4444 83.2095V40.0088C43.4444 30.739 50.86 23.2182 60.0001 23.2182V23.2182Z'
          fill='url(#paint1_linear_2080_38681)'
        />
        <path
          d='M102.596 1.79276C111.736 1.79276 119.152 9.31352 119.152 18.5833V77.7874C119.152 87.0572 111.736 94.578 102.596 94.578C93.4561 94.578 86.0406 87.0572 86.0406 77.7874V18.5833C86.0406 9.31352 93.4561 1.79276 102.596 1.79276V1.79276Z'
          fill='url(#paint2_linear_2080_38681)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2080_38681'
          x1='40.7713'
          y1='-17.7525'
          x2='-2.58906'
          y2='83.6026'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6B7280' />
          <stop offset='1' stopColor='#F3F4F6' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2080_38681'
          x1='83.3676'
          y1='5.42202'
          x2='40.0072'
          y2='106.777'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4B5563' />
          <stop offset='1' stopColor='#E5E7EB' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2080_38681'
          x1='121.178'
          y1='8.04548'
          x2='77.2808'
          y2='100.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#374151' />
          <stop offset='1' stopColor='#D1D5DB' />
        </linearGradient>
      </defs>
    </svg>
  )
}
